import { combineReducers } from "redux";

import LANG from "./Language";
import FILTER from "./SearchFilter";

export default combineReducers({
  LANG,
  FILTER,
});
